import dayjs from "dayjs";

const parsePerformerDateCopy = (performer) => {
	const dateFormat = "MMMM DD";
	let datesLength = performer.dates.length;
	let dateCopy;
	dateCopy = performer.isDaily
		? "Daily"
		: datesLength > 1
			? `${dayjs(performer.dates[0]).format(dateFormat)} & More`
			: datesLength == 1 && dayjs(performer.dates[0]).format(dateFormat);
	return dateCopy;
};

export default parsePerformerDateCopy;
